import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { EMRService } from 'app/EMR/EMR.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EyecheckComponent } from 'app/EMR/eyecheck/eyecheck.component';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { Additional_visionComponent } from '../additional_vision/additional_vision.component';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import * as moment from 'moment';
import { OptoModel } from 'app/EMR/PrimaryExaminationModels/opto.model';
import { HelplistService } from 'app/helplist.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { imageworkupService } from 'app/EMR/Image_workup/Services/Imageworkup.services';
import { WebSocketService } from 'app/EMR/webSocket.Service';

@Component({
  selector: 'app-glass_prescription',
  templateUrl: './glass_prescription.component.html',
  styleUrls: ['./glass_prescription.component.scss']
})
export class Glass_prescriptionComponent implements OnInit {
  destroyglass$: Subject<boolean> = new Subject<boolean>();
  @ViewChild('gprsd') gprsd: ElementRef;
  @ViewChild('gprcd') gprcd: ElementRef;
  @ViewChild('gprad') gprad: ElementRef;
  @ViewChild('gprpd') gprpd: ElementRef;
  @ViewChild('gprvd') gprvd: ElementRef;
  @ViewChild('gpnvr1') gpnvr1: ElementRef;
  @ViewChild('gprsn') gprsn: ElementRef;
  @ViewChild('gprcn') gprcn: ElementRef;
  @ViewChild('gpran') gpran: ElementRef;
  @ViewChild('gprpn') gprpn: ElementRef;
  @ViewChild('gprvn') gprvn: ElementRef;
  @ViewChild('gprsI') gprsI: ElementRef;
  @ViewChild('gprcI') gprcI: ElementRef;
  @ViewChild('gpraI') gpraI: ElementRef;
  @ViewChild('gprpI') gprpI: ElementRef;
  @ViewChild('gprvI') gprvI: ElementRef;
  @ViewChild('gplsd') gplsd: ElementRef;
  @ViewChild('gplcd') gplcd: ElementRef;
  @ViewChild('gplad') gplad: ElementRef;
  @ViewChild('gplps') gplps: ElementRef;
  @ViewChild('gplvd') gplvd: ElementRef;
  @ViewChild('gpnvl1') gpnvl1: ElementRef;
  @ViewChild('gplsn') gplsn: ElementRef;
  @ViewChild('gplcn') gplcn: ElementRef;
  @ViewChild('gplan') gplan: ElementRef;
  @ViewChild('gplpn') gplpn: ElementRef;
  @ViewChild('gplvn') gplvn: ElementRef;
  @ViewChild('gplsI') gplsI: ElementRef;
  @ViewChild('gplcI') gplcI: ElementRef;
  @ViewChild('gplaI') gplaI: ElementRef;
  @ViewChild('gplpI') gplpI: ElementRef;
  @ViewChild('gplvI') gplvI: ElementRef;
  // private boxDisabled: string = 'Add';
  private selectValue: any;
  private advisedName: string = '';
  private ischecked: boolean = false;
  private Optodata: OptoModel = {};
  private plusValues: any = [];
  private minusValues: any = [];
  private axisvalue: any = [];
  private prismvalue: any = [];
  private vaValue: any = [];
  private inputtype: string = null;
  private allowtablevalue: number = 0;
  @Input() showdglass_prescriptionmodel: any;
  @Output() parentdata: EventEmitter<any> = new EventEmitter();
  isheader: boolean = false;
  constructor(private webSocketService: WebSocketService, private helplistservice: HelplistService, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<Glass_prescriptionComponent>, private emrservice: EMRService, private authservice: AuthService, private branchMatserService: BranchMatserService,
    private dialog: MatDialog, private opdvisitService: OpdVisitService, private dashboardService: DashboardService, private datePipe: DatePipe, @Inject(PLATFORM_ID) private platformId: Object, private imageWorkupService: imageworkupService) {

  }

  ngOnInit() {
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
    this.emrservice.enabledisableGP = true;
    this.getBranchDetail(this.authservice.Loggeduser.branchid);

    this.get_old_photo();
    let countries;
    countries = this.helplistservice.eyevisiontypes_SPH.slice();
    this.plusValues = countries.filter((country) => country.popupDescription.startsWith("+"));
    this.minusValues = countries.filter((country) => country.popupDescription.startsWith("-"));
    this.axisvalue = this.helplistservice.eyevisiontypes_AXS.slice();
    this.prismvalue = this.helplistservice.eyevisiontypes_CYL.slice();
    this.vaValue = this.helplistservice.eyevisiontypes_VA.slice();

  }
  ngOnDestroy(): void {
    this.destroyglass$.next(true);
    this.destroyglass$.unsubscribe();
    this.Optodata = null;
    this.plusValues = null;
    this.minusValues = null;
    this.axisvalue = null;
    this.prismvalue = null;
    this.vaValue = null;

  }
  get_opto_data() {
    this.emrservice.get_opto_data().pipe(takeUntil(this.destroyglass$)).subscribe(data => {
      this.emrservice.opto = data;
      let advisedId = this.emrservice.opto.fkGpadvicedById;
      if (advisedId != 0 && advisedId != null) {
        let getAdvisedid = this.authservice.users.filter(item => item.pkUserId == advisedId)[0];
        this.ischecked = true;
        this.advisedName = getAdvisedid.userName;
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  advisedNamee(id) {
    if (id != 0 && id != null) {
      let getAdvisedid = this.authservice.users.filter(item => item.pkUserId == id)[0];
      if (getAdvisedid) {
        this.ischecked = true;
        return this.advisedName = getAdvisedid.userName
      } else {
        return null;
      }
    } else {
      this.advisedName = null;
      return this.advisedName;
    }
  }
  getsphvalue(category: string, valuebox: string) {
    this.emrservice.ar_value_box = valuebox;
    this.emrservice.eyechkcategory = category;
    const dialogRef = this.dialog.open(EyecheckComponent, {

      panelClass: 'full-width-dialog',

      // height: '80%',
      width: '100%',
      maxWidth: '50vw',
      data: {
        //category: category,
        //userid: this.authService.Loggeduser.userid
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyglass$)).subscribe(result => {
      this.emrservice.enabledisableGP = false;
      //  console.log('The dialog was closed');
      //pid = result;
      // this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory.slice());

    });
  }
  Checkipd($event) {
    this.emrservice.enabledisableGP = false;
  }
  addDisabledbox(value) {
    // this.boxDisabled = value;
    this.emrservice.opto.nearType = value;
    // this.emrservice.setAddNearValue({
    //   boxValue: this.boxDisabled
    // });
  }
  checknearvalue(value) {
    if (value) {
      return value;
    } else {
      this.emrservice.opto.nearType = 'Add';
      return 'Add';
    }
  }
  gpAdvisedBy(event) {

    let cancelchk = event.checked;
    this.emrservice.enabledisableGP = false;
    if (true == cancelchk) {
      this.advisedName = this.authservice.Loggeduser.username;
      this.emrservice.opto.fkGpadvicedById = this.authservice.Loggeduser.userid;
    } else {
      this.advisedName = '';
      this.emrservice.opto.fkGpadvicedById = null;
    }
  }

  get_old_photo() {
    this.opdvisitService.dataSource = [];
    this.imageWorkupService.getAzureImagedata(this.authservice.Loggeduser.userid, this.authservice.Loggeduser.branchid, 'DoctorSignature').subscribe(
      (data: any) => {
        this.opdvisitService.dataSource = data;
        if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'imageserver' && this.opdvisitService.dataSource.length > 0) {
          var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
          if (mainimagepath.length > 0) {
           
            const msg = { "message": "UPLOADFILE", "ACTIONTYPE": "VIEWFILE", "DOCUMENTNAME": this.opdvisitService.dataSource[0].documentName, "DOCUMENTTYPE": this.opdvisitService.dataSource[0].documentType.toUpperCase(), "BranchId": this.opdvisitService.dataSource[0].fk_BranchId.toString(), "PATIENTID": this.opdvisitService.dataSource[0].fk_RegId.toString(), "MAINIMAGEPATH": mainimagepath[0]?.propertyValue, }
            this.webSocketService.sendMessage(msg);
            this.webSocketService.getMessages().subscribe(
              (message: any) => {
                
                const filedat = message;
                if (Array.isArray(filedat)) {
                  this.signaturefileName = message[0].fbLong ? message[0].fbLong : message[0].documentURL + "?" + Math.floor(Math.random() * 100) + 1;
                }

              }, err => {
                this.dashboardService.openSnackBar("Please set server configuration", "OK");
              });
          } else {
            this.dashboardService.openSnackBar("Please set MainImagePath", "OK");
          }
        } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'server' && this.opdvisitService.dataSource.length > 0) {
          this.signaturefileName = data[0].fbLong ? data[0].fbLong : data[0].documentURL + "?" + Math.floor(Math.random() * 100) + 1;
        } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'azure' && this.opdvisitService.dataSource.length > 0) {
          this.signaturefileName = data[0].fbLong ? data[0].fbLong : data[0].documentURL + "?" + Math.floor(Math.random() * 100) + 1;
        } else {
          this.signaturefileName = ''
        }

      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });


  }
  signaturefileName: string = '';
  readFileAsDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }
  async onFileChange(event) {
    if (this.authservice.Loggeduser.userid) {

      var url = '';
      const formData = new FormData();
      if (this.authservice.webstorageConfigobj.storageType != null && this.authservice.webstorageConfigobj.storageType != undefined) {
        if (this.authservice.webstorageConfigobj.imageFileSize != null && this.authservice.webstorageConfigobj.imageFileSize != undefined && Number(this.authservice.webstorageConfigobj.imageFileSize) > 0) {
          if (Number(this.authservice.webstorageConfigobj.imageFileSize) * 1024 >= event.target.files[0].size) {

            const filedata = event.target.files[0];
            const formData = new FormData();
            if (filedata) {
              url = await this.readFileAsDataURL(event.target.files[0]);
            }
           
            formData.append('file', filedata, 'digisign_' + this.authservice.Loggeduser.userid);
            formData.append('documentname', 'DoctorSignature');
            formData.append('patientid', this.authservice.Loggeduser.userid?.toString());
            formData.append('branchId', this.authservice.Loggeduser.branchid.toString());
            formData.append('DocumentType', 'DoctorSignature');
            formData.append('PkTranId', this.opdvisitService.dataSource.length > 0 ? this.opdvisitService.dataSource[0]?.pk_TranId.toString() : '0');
            formData.append('ActionType', "UPLOAD");
            formData.append('StorageType', this.authservice.webstorageConfigobj.storageType.toString());
            if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'server') {
              this.dashboardService.subscriptions = this.imageWorkupService.uploadDoc(formData)
                .subscribe(
                  data => this.successfileupload(data), err => this.failedfileupload(err))
            } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'azure') {
              this.imageWorkupService.uploadAzureDoc(formData)
                .subscribe(
                  data => this.successfileupload(data), err => this.failedfileupload(err));
            } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'aws') {

            } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {

              var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
              if (mainimagepath.length > 0) {
                if (mainimagepath[0]?.propertyValue) {
                  const splitdata = url.split(',');
                  const docname = String('digisign_' + this.authservice.Loggeduser.userid) + '.png'
                  const message = {
                    "message": "UPLOADFILE",
                    "ACTIONTYPE": "UPLOAD",
                    "DOCUMENTTYPE": 'DoctorSignature',
                    "BranchId": this.authservice.Loggeduser.branchid.toString(),
                    "PATIENTID": this.authservice.Loggeduser.userid?.toString(),
                    "MAINIMAGEPATH": mainimagepath[0]?.propertyValue,
                    "DOCUMENTNAME": String(docname),
                    "CLIENTFILE": String(docname),
                    "fileData": String(splitdata[1])
                  };

                  this.webSocketService.sendMessage(message);
                  this.webSocketService.getMessages().subscribe(
                    (message: any) => {

                      if (message) {
                        this.dashboardService.openSnackBar(message, "OK");
                        this.webSocketService.disconnect();
                        let payload = {
                          "PatientDocumentDetail": {
                            "ActionType": "UPLOAD",
                            "Pk_TranId": this.opdvisitService.dataSource.length > 0 ? this.opdvisitService.dataSource[0].pk_TranId.toString() : '0',
                            "Fk_BranchId": this.authservice.Loggeduser.branchid.toString(),
                            "Fk_RegId": this.authservice.Loggeduser.userid?.toString(),
                            "Fk_CreatedById": this.authservice.Loggeduser.userid,
                            "DocumentType": 'DoctorSignature',
                            "DocumentName": String(docname),
                            "StorageType": this.authservice.webstorageConfigobj.storageType,
                            "DocumentURL": mainimagepath[0]?.propertyValue + '/' + 'DoctorSignature' + '/' + docname
                          }
                        }
                        this.imageWorkupService.UpdatePatientDocumentDetail(payload).subscribe((x: any) => {
                          this.get_old_photo();

                        });

                      }

                    }, err => {

                      this.dashboardService.openSnackBar("Please set server configuration", "OK");
                    });
                } else {
                  this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
                }
              } else {
                this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
              }
            }
            else {

              this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
            }
          } else {

            this.dashboardService.openSnackBar("Maximum File Size Allowed " + this.authservice.webstorageConfigobj.documentFileSize + ' Kb', "OK");
          }
        } else {

          this.dashboardService.openSnackBar("Document File Size Not Configured", "OK");
        }
      } else {

        this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
      }
    }
    else {
      this.dashboardService.openSnackBar("Login UserID Not Found", "OK");
    }

  }
  failedfileupload(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  successfileupload(data) {
    this.get_old_photo();
    this.dashboardService.openSnackBar("Successfully image uploaded", "OK");
  }
  refhelplistPOpup(type, value) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '50vw',
      disableClose: true,
      width: '35%',
      data: {
        typeid: type
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyglass$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisableGP = false;
        this.selectValue = result;
        if (type == 29) {
          this.emrservice.opto.gpremarks = this.selectValue;
        } else if (type == 23) {
          this.set_opto_gp_axis(value)
        }
      }
    });
  }

  set_opto_gp_axis(row) {
    switch (row) {
      // row 1
      case "r1c3_fg": {
        this.emrservice.opto.gprad = this.selectValue;
        break;
      }
      case "r1c9_fg": {
        this.emrservice.opto.gplad = this.selectValue;
        break;
      }

      // row 2 
      case "r2c3_fg": {
        this.emrservice.opto.gpran = this.selectValue;
        break;
      }
      case "r2c9_fg": {
        this.emrservice.opto.gplan = this.selectValue;
        break;
      }

      // row 3       
      case "r3c3_fg": {
        this.emrservice.opto.gpraI = this.selectValue;
        break;
      }
      case "r3c9_fg": {
        this.emrservice.opto.gplaI = this.selectValue;
        break;
      }
    }
  }

  // helplist pop up 
  refMultiPopup(name, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '50vw',
      disableClose: true,
      width: '35%',
      data: {
        parametertype: name
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyglass$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisableGP = false;
        if (type == 1) {
          this.emrservice.opto.gPdistPDR = result;
        } else if (type == 2) {
          // this.casetype = result;
          this.emrservice.opto.gPdistPDL = result;
        } else if (type == 3) {
          this.emrservice.opto.gPnearPDR = result;
        } else if (type == 4) {
          this.emrservice.opto.gPnearPDL = result;
        } else if (type == 5) {
          this.emrservice.opto.optoRemarks = result;
        } else if (type == 6) {
          this.emrservice.opto.delayedRemarks = result;
        } else if (type == 7) {
          this.emrservice.opto.typeofGlasses = result;
        }
      }
    });
  }
  //Transfer From UnDilated
  transfeUndilated() {
    let updateUnDItem = this.emrservice.opto;
    let objUndlength = Object.keys(updateUnDItem).length;
    if (updateUnDItem.pkOptId != 0) {
      this.emrservice.enabledisableGP = false;
      this.emrservice.opto["gprsd"] = updateUnDItem.udrs1 ? updateUnDItem.udrs1 : null;
      this.emrservice.opto["gprsn"] = updateUnDItem.udrs2 ? updateUnDItem.udrs2 : null;
      this.emrservice.opto["gprsI"] = updateUnDItem.udrs3 ? updateUnDItem.udrs3 : null;
      this.emrservice.opto["gprcd"] = updateUnDItem.udrc1 ? updateUnDItem.udrc1 : null;
      this.emrservice.opto["gprcn"] = updateUnDItem.udrc2 ? updateUnDItem.udrc2 : null;
      this.emrservice.opto["gprcI"] = updateUnDItem.udrc3 ? updateUnDItem.udrc3 : null;
      this.emrservice.opto["gprad"] = updateUnDItem.udra1 ? updateUnDItem.udra1 : null;
      this.emrservice.opto["gpran"] = updateUnDItem.udra2 ? updateUnDItem.udra2 : null;
      this.emrservice.opto["gpraI"] = updateUnDItem.udra3 ? updateUnDItem.udra3 : null;
      this.emrservice.opto["gprvd"] = updateUnDItem.udrv1 ? updateUnDItem.udrv1 : null;
      this.emrservice.opto["gprvn"] = updateUnDItem.udrv2 ? updateUnDItem.udrv2 : null;
      this.emrservice.opto["gprvI"] = updateUnDItem.udrv3 ? updateUnDItem.udrv3 : null;
      this.emrservice.opto["gprpd"] = updateUnDItem.udrp1 ? updateUnDItem.udrp1 : null;
      this.emrservice.opto["gprpn"] = updateUnDItem.udrp2 ? updateUnDItem.udrp2 : null;
      this.emrservice.opto["gprpI"] = updateUnDItem.udrp3 ? updateUnDItem.udrp3 : null;
      this.emrservice.opto["gpnvr1"] = updateUnDItem.udnvr1 ? updateUnDItem.udnvr1 : null;
      this.emrservice.opto["gplsd"] = updateUnDItem.udls1 ? updateUnDItem.udls1 : null;
      this.emrservice.opto["gplsn"] = updateUnDItem.udls2 ? updateUnDItem.udls2 : null;
      this.emrservice.opto["gplsI"] = updateUnDItem.udls3 ? updateUnDItem.udls3 : null;
      this.emrservice.opto["gplcd"] = updateUnDItem.udlc1 ? updateUnDItem.udlc1 : null;
      this.emrservice.opto["gplcn"] = updateUnDItem.udlc2 ? updateUnDItem.udlc2 : null;
      this.emrservice.opto["gplcI"] = updateUnDItem.udlc3 ? updateUnDItem.udlc3 : null;
      this.emrservice.opto["gplad"] = updateUnDItem.udla1 ? updateUnDItem.udla1 : null;
      this.emrservice.opto["gplan"] = updateUnDItem.udla2 ? updateUnDItem.udla2 : null;
      this.emrservice.opto["gplaI"] = updateUnDItem.udla3 ? updateUnDItem.udla3 : null;
      this.emrservice.opto["gplvd"] = updateUnDItem.udlv1 ? updateUnDItem.udlv1 : null;
      this.emrservice.opto["gplvn"] = updateUnDItem.udlv2 ? updateUnDItem.udlv2 : null;
      this.emrservice.opto["gplvI"] = updateUnDItem.udlv3 ? updateUnDItem.udlv3 : null;
      this.emrservice.opto["gplps"] = updateUnDItem.udlp1 ? updateUnDItem.udlp1 : null;
      this.emrservice.opto["gplpn"] = updateUnDItem.udlp2 ? updateUnDItem.udlp2 : null;
      this.emrservice.opto["gplpI"] = updateUnDItem.udlp3 ? updateUnDItem.udlp3 : null;
      this.emrservice.opto["gpnvl1"] = updateUnDItem.udnvl1 ? updateUnDItem.udnvl1 : null;
      this.authservice.openSnackBar("Record Transferred Successfully", "OK");
    }
  }
  //Transfer From Dilated
  transferDilated() {

    let updateDilated = this.emrservice.opto;
    let objDlength = Object.keys(updateDilated).length;
    if (updateDilated.pkOptId != 0) {
      this.emrservice.enabledisableGP = false;
      this.emrservice.opto["gprsd"] = updateDilated.drs1 ? updateDilated.drs1 : null;
      this.emrservice.opto["gprcd"] = updateDilated.drc1 ? updateDilated.drc1 : null;
      this.emrservice.opto["gprad"] = updateDilated.dra1 ? updateDilated.dra1 : null;
      this.emrservice.opto["gprvd"] = updateDilated.drv1 ? updateDilated.drv1 : null;
      this.emrservice.opto["gplsd"] = updateDilated.dls1 ? updateDilated.dls1 : null;
      this.emrservice.opto["gplcd"] = updateDilated.dlc1 ? updateDilated.dlc1 : null;
      this.emrservice.opto["gplad"] = updateDilated.dla1 ? updateDilated.dla1 : null;
      this.emrservice.opto["gplvd"] = updateDilated.dlv1 ? updateDilated.dlv1 : null;
      this.authservice.openSnackBar("Record Transferred Successfully", "OK");
    }
  }
  //Transfer From POG
  transferPOG() {

    let updatePOG = this.emrservice.autoref;
    let objlength = Object.keys(updatePOG).length;
    if (updatePOG.pkTranId != 0) {
      this.emrservice.enabledisableGP = false;
      this.emrservice.opto["gprsd"] = updatePOG.odSph ? updatePOG.odSph : null;
      this.emrservice.opto["gprcd"] = updatePOG.odCyl ? updatePOG.odCyl : null;
      this.emrservice.opto["gprad"] = updatePOG.odAxis ? updatePOG.odAxis : null;
      this.emrservice.opto["gprvd"] = updatePOG.odDbscva ? updatePOG.odDbscva : null;
      this.emrservice.opto["gprsn"] = updatePOG.odAdd ? updatePOG.odAdd : null;
      this.emrservice.opto["gprvn"] = updatePOG.odBscva ? updatePOG.odBscva : null;
      this.emrservice.opto["gplsd"] = updatePOG.osSph ? updatePOG.osSph : null;
      this.emrservice.opto["gplcd"] = updatePOG.osCyl ? updatePOG.osCyl : null;
      this.emrservice.opto["gplad"] = updatePOG.osAxis ? updatePOG.osAxis : null;
      this.emrservice.opto["gplvd"] = updatePOG.osDbscva ? updatePOG.osDbscva : null;
      this.emrservice.opto["gplsn"] = updatePOG.osAdd ? updatePOG.osAdd : null;
      this.emrservice.opto["gplvn"] = updatePOG.osBscva ? updatePOG.osBscva : null;
      this.authservice.openSnackBar("Record Transferred Successfully", "OK");
    }
  }

  getsummary_url(patientid: number) {
    if (this.opdvisitService.patientdetails.pkRegId) {
      this.dashboardService.subscriptions = this.dashboardService.getsummary_url().subscribe(
        data => this.succesurl(data, patientid), err => this.failedurl(err)
      )
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }

  succesurl(data, patientid) {

    const urldate = data.filter(item => item.propertyName == 'WebURL');
    const url = urldate[0].propertyValue;
    const prourl = data.filter(item => item.propertyName == 'WebGlassPrescriptionPageName');
    var pageNameurl: string = '';
    if (prourl.length > 0) {
      pageNameurl = prourl[0]?.propertyValue ? prourl[0]?.propertyValue : 'GlassPrescription.aspx';
    } else {
      pageNameurl = 'GlassPrescription.aspx';
    }
    window.open(url + pageNameurl + '?RegID=' + patientid + '&BillCompanyName=' + this.authservice.Loggeduser.billingcompanyname + '&VisitId=' + this.emrservice.visitid + '&BranchId=' + this.authservice.Loggeduser.branchid + '&PageHeadWebReport=Y' + '&VisitDate=' + this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd"));

  }
  failedurl(err) {

  }
  // helplist pop up 
  additioalVision() {
    const dialogRef = this.dialog.open(Additional_visionComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '77vw',
      disableClose: true,
      width: '77%',
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyglass$)).subscribe(result => {
      this.emrservice.enabledisableGP = false;
      if (result != 0) {

      }
    });
  }
  branchmansterObj: any = {};
  getBranchDetail(id) {
    this.branchmansterObj = {};
    this.branchMatserService.getBrachMasterItem(id).pipe(takeUntil(this.destroyglass$)).subscribe((x: any) => {
      this.branchmansterObj = x[0];
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  printTimeline() {

    let checkreporttype = this.authservice.webreportConfig.filter(item => item.printOption == 'Glass Prescription' && item.printType == 'NetramReport');
    if (checkreporttype.length > 0) {
      this.getsummary_url(this.opdvisitService.patientdetails.pkRegId);
    } else {
      this.printTimelinedata();
    }

  }
  printTimelinedata() {
    this.Optodata = {};
    this.emrservice.get_opto_data().pipe(takeUntil(this.destroyglass$)).subscribe(data => {
      this.Optodata = data;
      let advisedId = this.Optodata.fkGpadvicedById;
      if (advisedId != 0 && advisedId != null) {
        let getAdvisedid = this.authservice.users.filter(item => item.pkUserId == advisedId)[0];
        this.ischecked = true;
        this.advisedName = getAdvisedid.userName;
      }

      this.Optodata.visitDate = this.datePipe.transform(this.emrservice.visitDate, "dd/MM/yyyy");
      let payload = {
        "WebReportPrintMaster": {
          "module": "Primary Exam",
          "printOption": "Glass Prescription",
          "printType": "WebNetramReport",
          "PATIENTNAME": this.opdvisitService.patientdetails.firstName +
            " " +
            this.opdvisitService.patientdetails.lastName,
          "MRDNO": this.opdvisitService.patientdetails.pkRegId,
          "MobileNo": this.opdvisitService.patientdetails.mobileNo,
          "PatientAddress": this.opdvisitService.patientdetails.paddress,
          "PRINTDATE": this.datePipe.transform(this.authservice.localDate, "dd/MM/yyyy"),
          "PrintTime": this.convertTime12Hour(new Date()),
          "PatientAge": this.opdvisitService.patientdetails.ageYear,
          "PatientGender": this.opdvisitService.patientdetails.sex,
          "PatientAgeAndGender": this.opdvisitService.patientdetails.ageYear + '|' + this.opdvisitService.patientdetails.sex,
          "BILLINGCOMPANYNAME": this.authservice.Loggeduser.billingcompanyname,
          "LINE1": this.branchmansterObj.line1,
          "LINE2": this.branchmansterObj.line2,
          "LINE3": this.branchmansterObj.line3,
          "LINE4": this.branchmansterObj.line4,
          "HOSPITALIMAGE": "../../../" + this.authservice.loginclientlogo,
          "COMPANYIMAGE": "../../../" + this.authservice.leftbottomlogosm,
          "CERTIFICATE1IMAGE": "../../../" + this.authservice.nabhlogo,
          "CERTIFICATE2COMPANYIMAGE": this.signaturefileName,
          "GpAdvisedBy": this.advisedName,
          ...this.Optodata,
          "PrintHeaderArray": 'Y',
          "PatientRegistrationArray": 'Y',


        }

      }

      this.emrservice.GetWebReportPrint(payload).pipe(takeUntil(this.destroyglass$)).subscribe((x: any) => {
        if (x.length > 0) {
          let printContents, popupWin;

          printContents = x[0].printTemplate;
          popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

          popupWin.document.open();
          popupWin.document.write(`
      <html>
       
    <body onload="window.print()">${printContents}
    </body>
      </html>`
          );

          popupWin.document.close();
        } else {
          this.dashboardService.openSnackBar("Report Template Not Set", "OK");
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != '') {
      let hour = (this.timecheck.split(':'))[0]
      let min = (this.timecheck.split(':'))[1]
      let part = hour > 12 ? 'PM' : 'AM';

      min = (min + '').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + '').length == 1 ? `0${hour}` : hour;

      return (`${hour}:${min} ${part}`)
    } else {
      return null;
    }

  }

  refractionModal() {
    if (this.emrservice.glassPrescriptionPermission?.isAddPermission == true) {
      document.getElementById("glassprescrptionModal").style.display = "block";
      this.inputtype = null;
      this.allowtablevalue = 0;
      this.emrservice.optohelplist = this.emrservice.opto;
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  cancelRefractionModal() {
    document.getElementById("glassprescrptionModal").style.display = "none";
    this.emrservice.optohelplist = {};
    this.get_opto_data();

  }
  focusFunction(type, value) {
    this.inputtype = type;
    this.allowtablevalue = value;

  }
  updateData() {
    this.emrservice.enabledisableGP = false;
    this.emrservice.opto = this.emrservice.optohelplist;
    document.getElementById("glassprescrptionModal").style.display = "none";
  }
  selectrowVlaue(row, type) {
    if (type == this.allowtablevalue) {

      switch (this.inputtype) {
        case "gprsd": {
          this.emrservice.optohelplist.gprsd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprcd'].nativeElement.focus();
          }
          break;
        }
        case "gprcd": {
          this.emrservice.optohelplist.gprcd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprad'].nativeElement.focus();
          }
          break;
        }
        case "gprad": {
          this.emrservice.optohelplist.gprad = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprpd'].nativeElement.focus();
          }
          break;
        }
        case "gprpd": {
          this.emrservice.optohelplist.gprpd = row.popupDescription;
          this.emrservice.optohelplist.gprad = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprvd'].nativeElement.focus();
          }
          break;
        }
        case "gprvd": {
          this.emrservice.optohelplist.gprvd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gpnvr1'].nativeElement.focus();
          }
          break;
        }
        case "gpnvr1": {
          this.emrservice.optohelplist.gpnvr1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprsn'].nativeElement.focus();
          }
          break;
        }
        case "gprsn": {
          this.emrservice.optohelplist.gprsn = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprcn'].nativeElement.focus();
          }
          break;
        }
        case "gprcn": {
          this.emrservice.optohelplist.gprcn = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gpran'].nativeElement.focus();
          }
          break;
        }
        case "gpran": {
          this.emrservice.optohelplist.gpran = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprpn'].nativeElement.focus();
          }
          break;
        }
        case "gprpn": {
          this.emrservice.optohelplist.gprpn = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprvn'].nativeElement.focus();
          }
          break;
        }
        case "gprvn": {
          this.emrservice.optohelplist.gprvn = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprsI'].nativeElement.focus();
          }
          break;
        }
        case "gprsI": {
          this.emrservice.optohelplist.gprsI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprcI'].nativeElement.focus();
          }
          break;
        }
        case "gprcI": {
          this.emrservice.optohelplist.gprcI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gpraI'].nativeElement.focus();
          }
          break;
        }
        case "gpraI": {
          this.emrservice.optohelplist.gpraI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprpI'].nativeElement.focus();
          }
          break;
        }
        case "gprpI": {
          this.emrservice.optohelplist.gprpI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprvI'].nativeElement.focus();
          }
          break;
        }
        case "gprvI": {
          this.emrservice.optohelplist.gprvI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplsd'].nativeElement.focus();
          }
          break;
        }
        case "gplsd": {
          this.emrservice.optohelplist.gplsd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplcd'].nativeElement.focus();
          }
          break;
        }
        case "gplcd": {
          this.emrservice.optohelplist.gplcd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplad'].nativeElement.focus();
          }
          break;
        }
        case "gplad": {
          this.emrservice.optohelplist.gplad = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplps'].nativeElement.focus();
          }
          break;
        }
        case "gplps": {
          this.emrservice.optohelplist.gplps = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplvd'].nativeElement.focus();
          }
          break;
        }
        case "gplvd": {
          this.emrservice.optohelplist.gplvd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gpnvl1'].nativeElement.focus();
          }
          break;
        }
        case "gpnvl1": {
          this.emrservice.optohelplist.gpnvl1 = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplsn'].nativeElement.focus();
          }
          break;
        }
        case "gplsn": {
          this.emrservice.optohelplist.gplsn = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplcn'].nativeElement.focus();
          }
          break;
        }
        case "gplcn": {
          this.emrservice.optohelplist.gplcn = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplan'].nativeElement.focus();
          }
          break;
        }
        case "gplan": {
          this.emrservice.optohelplist.gplan = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplpn'].nativeElement.focus();
          }
          break;
        }
        case "gplpn": {
          this.emrservice.optohelplist.gplpn = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplvn'].nativeElement.focus();
          }
          break;
        }
        case "gplvn": {
          this.emrservice.optohelplist.gplvn = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplsI'].nativeElement.focus();
          }
          break;
        }
        case "gplsI": {
          this.emrservice.optohelplist.gplsI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplcI'].nativeElement.focus();
          }
          break;
        }
        case "gplcI": {
          this.emrservice.optohelplist.gplcI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplaI'].nativeElement.focus();
          }
          break;
        }
        case "gplaI": {
          this.emrservice.optohelplist.gplaI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplpI'].nativeElement.focus();
          }
          break;
        }
        case "gplpI": {
          this.emrservice.optohelplist.gplpI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gplvI'].nativeElement.focus();
          }
          break;
        }
        case "gplvI": {
          this.emrservice.optohelplist.gplvI = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['gprsd'].nativeElement.focus();
          }
          break;
        }
      }
    } else {
      this.dashboardService.openSnackBar("Select Correct Value", "OK");
    }
  }
  closedialog() {
    this.dialogRef.close();
  }
}
